import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckSiteIdsFilter } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_SITEID_FILTER } from '@constants/queryKeys';

export const useQueryHistoryCheckSiteIdsFilter = (comparisonId: string) => {
	const { data: siteIdFilterOptions } = useQuery<string[], TSelectOption[]>({
		queryKey: [HISTORY_CHECK_SITEID_FILTER, comparisonId],
		queryFn: extractQueryParams(getHistoryCheckSiteIdsFilter),
		select: (options) => fieldsOptionsFormatted(options || []),
		enabled: [!!comparisonId],
		...refetchOptions,
	});

	return {
		siteIdFilterOptions: siteIdFilterOptions || [],
	};
};
